import { useWatch } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';

import { Button } from '@/modules/ui';

import type { ReviewPrizepoolFormValues } from '../../../../schemas';

export interface FormButtonsProps {
    isSubmitting: boolean;
    onClose: () => void;
}

export const FormButtons = ({ isSubmitting, onClose }: FormButtonsProps) => {
    const trustpilotVisited = useWatch<ReviewPrizepoolFormValues>({ name: 'trustpilotVisited' });
    const g2Visited = useWatch<ReviewPrizepoolFormValues>({ name: 'g2Visited' });

    return (
        <>
            <Button type='primary' size='large' htmlType='submit' disabled={!trustpilotVisited && !g2Visited} loading={isSubmitting}>
                <FormattedMessage id='review-prizepool.form.button.submit' />
            </Button>
            <Button type='default' size='large' htmlType='button' onClick={onClose} disabled={isSubmitting}>
                <FormattedMessage id='review-prizepool.form.button.close' />
            </Button>
        </>
    );
};
